import { Config } from './../config/config';
var MixpanelService = (function () {
    function MixpanelService() {
        this.api = require('mixpanel-browser');
        this.api.init(Config.getEnvironmentVariable("mixpanel_api"));
    }
    MixpanelService.prototype.trackEvent = function (event, orderType) {
        try {
            if (!sessionStorage.getItem(event)) {
                sessionStorage.setItem(event, event);
            }
        }
        catch (exception) {
            return null;
        }
        finally {
            if (orderType) {
                console.log("track event: ", event, " odertype : ", orderType);
                this.api.track(event, { "orderType": orderType });
            }
            else {
                console.log("track event: ", event);
                this.api.track(event);
            }
        }
    };
    return MixpanelService;
}());
export { MixpanelService };
//# sourceMappingURL=mixpanel.service.js.map


//////////////////
// WEBPACK FOOTER
// ./src/app/mixpanel/mixpanel.service.js
// module id = 26
// module chunks = 0